
        <video
            #video
            muted
            playsinline
            preload="auto"
            [poster]="poster"
            [src]="videoSrc"
            [style.visibility]="hidden ? 'hidden' : 'visible'"
            (ended)="onEnded()"
            (canplay)="onCanplay()"
        ></video>
    